import {ModuleComponent} from "../../js/module-component";

/**
 * Beneficios "¿Qué consigue Seion?" (SEION).
 *  - Selector de 6 beneficios con auto-avance en bucle y barra de progreso.
 *  - Pausa al pasar el ratón; selección manual por click/hover.
 *  El reveal de entrada es animación CSS directa (no clase mutada). La barra
 *  de progreso es una animación CSS que se REINICIA re-lanzándola (nunca vive
 *  en el estado). Respeta prefers-reduced-motion.
 */
export class ModAgentsFour extends ModuleComponent{

    ready(){
        super.ready();
        this.el = this.$root.get(0);
        if(!this.el) return;

        this.scope = "web-mod-agents-four";
        this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.dwell = 5200;

        // Datos (fallback + JSON traducido del Twig).
        this.benefits = [];
        const dataEl = this.el.querySelector(".js-agents-four-data");
        if(dataEl){
            try { const p = JSON.parse(dataEl.textContent); if(Array.isArray(p) && p.length) this.benefits = p; } catch(e){}
        }
        if(!this.benefits.length) return;

        this.root = this.el.querySelector(".js-root");
        this.rows = Array.from(this.el.querySelectorAll(".js-row"));
        this.stageNum = this.el.querySelector(".js-stage-num");
        this.stageTag = this.el.querySelector(".js-stage-tag");
        this.stageBody = this.el.querySelector(".js-stage-body");
        this.stageTitle = this.el.querySelector(".js-stage-title");
        this.stageText = this.el.querySelector(".js-stage-text");
        this.jsBefore = this.el.querySelector(".js-before");
        this.jsAfter = this.el.querySelector(".js-after");
        this.check = this.el.querySelector("." + this.scope + "__check");
        this.chipsBox = this.el.querySelector(".js-chips");

        this.active = 0;
        this.paused = false;

        // Selección manual (click + hover).
        this.rows.forEach((row) => {
            const i = Number(row.dataset.index || 0);
            const select = () => this.pick(i);
            row.addEventListener("click", select);
            row.addEventListener("pointerenter", select);
        });

        // Pausa mientras el ratón está sobre el módulo.
        if(this.root){
            this.onEnter = () => { clearTimeout(this.timer); this.paused = true; this.setBarState("paused"); };
            this.onLeave = () => { this.paused = false; this.setBarState("running"); this.schedule(); };
            this.root.addEventListener("pointerenter", this.onEnter);
            this.root.addEventListener("pointerleave", this.onLeave);
        }

        this.updateBars();
        this.schedule();
    }

    schedule(){
        if(this.reduceMotion) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.pick((this.active + 1) % this.benefits.length, true);
        }, Math.max(2000, this.dwell));
    }

    pick(i, fromTimer){
        this.active = i;
        this.updateRows();
        this.updateStage();
        this.updateBars();
        if(!this.paused) this.schedule();
    }

    updateRows(){
        this.rows.forEach((row, i) => row.classList.toggle("is-active", i === this.active));
    }

    // Barra de progreso: se reinicia relanzando la animación (no vive en state).
    updateBars(){
        this.rows.forEach((row, i) => {
            const fill = row.querySelector(".js-bar-fill");
            if(!fill) return;
            if(i === this.active && !this.reduceMotion){
                fill.style.animation = "none";
                void fill.offsetWidth;                 // fuerza reflow para reiniciar
                fill.style.animation = "a04Bar " + Math.max(2000, this.dwell) + "ms linear forwards";
                fill.style.animationPlayState = this.paused ? "paused" : "running";
            }else{
                fill.style.animation = "none";
                fill.style.transform = "scaleX(0)";
            }
        });
    }

    setBarState(state){
        const fill = this.rows[this.active] && this.rows[this.active].querySelector(".js-bar-fill");
        if(fill) fill.style.animationPlayState = state;
    }

    updateStage(){
        const b = this.benefits[this.active];
        if(!b) return;
        if(this.stageNum) this.stageNum.textContent = "0" + (this.active + 1);
        if(this.stageTag) this.stageTag.textContent = b.tag;
        if(this.stageTitle) this.stageTitle.textContent = b.title;
        if(this.stageText) this.stageText.textContent = b.text;

        // "Antes": texto.
        if(this.jsBefore) this.jsBefore.textContent = b.before;
        // "Con SEION": texto + reinicio del check.
        if(this.jsAfter) this.jsAfter.textContent = b.after;
        this.restart(this.check);

        // Chips.
        if(this.chipsBox){
            this.chipsBox.textContent = "";
            (b.chips || []).forEach((text) => {
                const chip = document.createElement("span");
                chip.className = this.scope + "__chip";
                const dot = document.createElement("span");
                dot.className = this.scope + "__chip-dot";
                chip.appendChild(dot);
                chip.appendChild(document.createTextNode(text));
                this.chipsBox.appendChild(chip);
            });
        }

        // Reinicia la entrada del bloque (bnSwap → a04Swap).
        this.restart(this.stageBody);
    }

    // Reinicia una animación CSS ya definida por clase.
    restart(el){
        if(!el || this.reduceMotion) return;
        el.style.animation = "none";
        void el.offsetWidth;
        el.style.animation = "";
    }

    destroy(){
        clearTimeout(this.timer);
        if(this.root && this.onEnter){
            this.root.removeEventListener("pointerenter", this.onEnter);
            this.root.removeEventListener("pointerleave", this.onLeave);
        }
        if(super.destroy) super.destroy();
    }
}
